import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { AuthenticationService } from './core/services/authentication.service';
import { SidebarComponent } from './core/layouts/sidebar/sidebar.component';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter, map } from 'rxjs/operators';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
	loginUser: any;
	title = 'InsiderSys';
	fixedWord = "InsiderSys"; // 👈 Your NEW fixed word


	constructor(
		public translate: TranslateService,
		public authenticationService: AuthenticationService,
		private activatedRoute: ActivatedRoute,
		private titleService: Title,
		private router: Router,
	) {

		this.authenticationService.loginUser.subscribe(x => this.loginUser = x);
		if (this.loginUser) {
			// translate.setDefaultLang(this.loginUser.language);
			//translate.use(this.loginUser.language);
			translate.setDefaultLang('en');
			translate.use('en');
		} else {
			translate.setDefaultLang('en');
			translate.use('en');
		}

		if (localStorage.getItem("permissions") != 'undefined' && localStorage.getItem("permissions") != null) {

			authenticationService.setUserPermissions(JSON.parse(localStorage.getItem("loginUser")));
		}

		// this.router.events
		// 	.pipe(filter(event => event instanceof NavigationEnd))
		// 	.pipe(map(() => {
		// 		let child = this.activatedRoute.firstChild;
		// 		while (child.firstChild) child = child.firstChild;
		// 		return child.snapshot.data['title'] || null;
		// 	}))
		// 	.subscribe(title => {
		// 		if (title) {
		// 			this.titleService.setTitle(`${title} | ${this.fixedWord}`);
		// 		} else {
		// 			this.titleService.setTitle(this.fixedWord);
		// 		}
		// 	});
	}

	ngOnInit() { }

}